import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { LineChart } from "@mui/x-charts/LineChart";
import moment from "moment/moment";
export default function LineChartCard(props) {
  const { name, data, caption } = props;
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack
          direction="column"
          sx={{ justifyContent: "space-between", flexGrow: "1", gap: 1 }}
        >
          <Stack sx={{ justifyContent: "space-between" }}>
            <Stack
              direction="column"
              sx={{
                alignItems: "center",
              }}
            >
              <Typography variant="p" component="p">
                {name}
              </Typography>
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {caption}
              </Typography>
            </Stack>
          </Stack>
          <Box sx={{ width: "100%", height: "100%" }}>
            <LineChart
              {...data}
              xAxis={[{ scaleType: "point", data: moment.monthsShort() }]}
            />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
